import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import IArborStudentUserTypeMapping from "../../../../models/misconfig/arbor/userTypes/ArborStudentUserTypeMapping";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { IArborUserTypeSubEditProps } from "./arbor-usertype-edit";

const ArborStudentUserTypeEdit = forwardRef((props: IArborUserTypeSubEditProps, ref) => {
    const [arborConfig, setArborConfig] = useState<IArborStudentUserTypeMapping | null>(null);
    const hasInitializedRef = useRef<boolean>(false);

    useEffect(() => {   
        if(!props.configJson) {
            hasInitializedRef.current = false;
            setArborConfig(null);
        } else if (props.configJson && !hasInitializedRef.current) {
            const configObj: IArborStudentUserTypeMapping = JSON.parse(props.configJson);
            setArborConfig(configObj);
            hasInitializedRef.current = true;
        }
    }, [props.configJson]);    

    useImperativeHandle(ref, () => ({
        validate: function() : boolean {
           return true;
        }}));

     const updateEnrollmentModes = (index: number, type: string, value: string) => {     
        if(type === 'R') {
            const updatedR = [...arborConfig?.RequiredEnrollmentModes || []];
            updatedR[index] = value;   
            setArborConfig(prev => ({...prev!, RequiredEnrollmentModes: updatedR})); 
            props.handleChange('RequiredEnrollmentModes', updatedR);        
            return                      
        } else if(type === 'E') {
            const updatedE = [...arborConfig?.ExcludeEnrollmentModes || []];
            updatedE[index] = value;
            setArborConfig(prev => ({...prev!, ExcludeEnrollmentModes: updatedE}));
            props.handleChange('ExcludeEnrollmentModes', updatedE);
            return;
        }
    }

    const removeEnrollmentModes = (index: number, type: string) => {   
        if(type === 'R') {
            const updatedR = arborConfig?.RequiredEnrollmentModes.filter((_, idx) => idx !== index) || [];            
            setArborConfig(prev => ({...prev!, RequiredEnrollmentModes: updatedR}));
            props.handleChange('RequiredEnrollmentModes', updatedR);
            return;
        } else if(type === 'E') {
            const updatedE = arborConfig?.ExcludeEnrollmentModes.filter((_, idx) => idx !== index) || [];
            setArborConfig(prev => ({...prev!, ExcludeEnrollmentModes: updatedE})); 
            props.handleChange('ExcludeEnrollmentModes', updatedE);
            return;
        }        
    }

    const appendEnrollmentModes = (type: string) => {
        if(type === 'R') {
            const updatedR = [...arborConfig?.RequiredEnrollmentModes || [], ''];
            setArborConfig(prev => ({...prev!, RequiredEnrollmentModes: updatedR}));   
            props.handleChange('RequiredEnrollmentModes', updatedR); 
            return;
        } else if(type === 'E') {
            const updatedE = [...arborConfig?.ExcludeEnrollmentModes || [], ''];
            setArborConfig(prev => ({...prev!, ExcludeEnrollmentModes: updatedE}));
            props.handleChange('ExcludeEnrollmentModes', updatedE);
            return;
        }        
    }

    const handleIncluedePrestartStudentsChange = (value: boolean) => {
        setArborConfig(prev => ({...prev!, IncludePrestartStudents: value}));
        props.handleChange('IncludePrestartStudents', value);
    }

    return (
        <React.Fragment>
            <Row className="pb-3">
                <Col md={props.firstCol} className="pt-2">Include prestart students?</Col>
                <Col md={props.secondCol}>
                    <select className="form-select mt-1 ms-0 w-100" value={arborConfig?.IncludePrestartStudents ? 'true' : 'false'}
                        onChange={e => handleIncluedePrestartStudentsChange(e.target.value === 'true')}>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </Col>
            </Row>
            {arborConfig?.RequiredEnrollmentModes?.map((value, idx) => (
            <Row className="pb-2" key={`requiredEnrollmentModes-${idx}`}>  
                <Col md={2}>{idx === 0 ? 'Required Enrollment Modes' : ''}</Col>
                <Col md={4}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Required Enrollment Modes"
                        value={value}
                        onChange={(e) => updateEnrollmentModes(idx, 'R', e.target.value)} />
                </Col>
                <Col md={2}>
                    <button type="button" className="btn btn-light red-color" onClick={() => removeEnrollmentModes(idx, 'R')}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                </Col>
            </Row>
            ))}
            <Row className="pb-3">
                <Col md={props.firstCol}>{
                        arborConfig === null 
                        || arborConfig.RequiredEnrollmentModes === undefined 
                        || arborConfig.RequiredEnrollmentModes.length === 0 ? 'Required Enrollment Modes' : ''
                    }</Col>
                <Col md={props.secondCol}>  
                    <button 
                        type="button" 
                        className="btn" 
                        onClick={() => appendEnrollmentModes('R')}style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Required Enrollment mode">+ Add New</button>
                </Col>
            </Row>
            {arborConfig?.ExcludeEnrollmentModes?.map((value, idx) => (
            <Row className="pb-2" key={`excludeEnrollmentModes-${idx}`}>  
                <Col md={2}>{idx === 0 ? 'Exclude Enrollment Modes' : ''}</Col>
                <Col md={4}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Exclude Enrollment Modes"
                        value={value}
                        onChange={(e) => updateEnrollmentModes(idx, 'E', e.target.value)} />
                </Col>
                <Col md={2}>
                    <button type="button" className="btn btn-light red-color" onClick={() => removeEnrollmentModes(idx, 'E')}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                </Col>
            </Row>  
            ))}
            <Row className="pb-3">
                <Col md={props.firstCol}>{
                        arborConfig === null 
                        || arborConfig.ExcludeEnrollmentModes === undefined 
                        || arborConfig.ExcludeEnrollmentModes.length === 0 ? 'Exclude Enrollment Modes' : ''
                    }</Col>
                <Col md={props.secondCol}>
                    <button 
                        type="button" 
                        className="btn" 
                        onClick={() => appendEnrollmentModes('E')}
                        style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Exclude Enrollment mode">+ Add New</button>
                </Col>
            </Row>
        </React.Fragment>
    );
});

export default ArborStudentUserTypeEdit;